import { render, staticRenderFns } from "./InputGeneralRegister.vue?vue&type=template&id=334ed5fa&lang=html"
import script from "./InputGeneralRegister.vue?vue&type=script&lang=js"
export * from "./InputGeneralRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports